"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionLabelSingleLine = exports.defaultAddressFormat = void 0;
const getOptionLabelSingleLine = (lineNumber, item, addressFormat) => {
  if (addressFormat.lines[lineNumber]) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- we need
    const {
      fields,
      separators
    } = addressFormat.lines[lineNumber];
    let result = '';
    fields.forEach((field, idx) => {
      const correctField = field.charAt(0).toLowerCase() + field.slice(1);
      if (correctField === 'zipCode') {
        result += `${item.zipcode}${separators[idx + 1]}`;
      } else {
        const newField = item[correctField];
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
        if (newField && newField !== '') {
          result += `${newField}${separators[idx + 1]}`;
        }
      }
    });
    return `${separators[0]}${result}${separators.at(-1)}`;
  }
  return item.streetAddress ?? '';
};
exports.getOptionLabelSingleLine = getOptionLabelSingleLine;
const defaultAddressFormat = exports.defaultAddressFormat = {
  type: 'SingleLine',
  lines: [{
    fields: ['streetAddress'],
    separators: ['', '']
  }]
};